/**
 * @description 公共函数集合 / 若项目规模扩大可再细分
 * @author cht
 */

'use strict'
import JSEncrypt from 'jsencrypt'

/**
 * @description 判断是否为VNode
 * @param {Object} node 被判断对象
 */
function selfIsVNode (node) {
  return (
    node !== null &&
    typeof node === 'object' &&
    node.hasOwnProperty('componentOptions')
  )
}


/**
 * @description RSA加密
 * @param {String} data
 * @param {String} key
 */
function getRsaString(data, publicKey) {
  let encrypt = new JSEncrypt()
  encrypt.setPublicKey(publicKey)
  return encrypt.encrypt(data)
}

/**
 * @description 生成随机数
 * @param {Number} len 随机字符串长度
 */
function randStr(len) {
  let resLists = [
    0,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    '.',
    '@',
    '_',
    '-',
    'a',
    'b',
    'c',
    'd',
    'e',
    'f',
    'g',
    'h',
    'i',
    'j',
    'k',
    'l',
    'm',
    'n',
    'o',
    'p',
    'q',
    'r',
    's',
    't',
    'u',
    'v',
    'w',
    'x',
    'y',
    'z',
    'A',
    'B',
    'C',
    'D',
    'E',
    'F',
    'G',
    'H',
    'I',
    'J',
    'K',
    'L',
    'M',
    'N',
    'O',
    'P',
    'Q',
    'R',
    'S',
    'T',
    'U',
    'V',
    'W',
    'X',
    'Y',
    'Z'
  ]
  let tarStr = ''
  for (let i = 0; i < len; i++) {
    let ran = Math.floor(Math.random() * 66)
    tarStr += resLists[ran]
  }
  return tarStr
}

// 转化日期格式
function changeDateFormat(date) {
  if (String(date).indexOf('-') !== -1) {
    return
  }
  let year = date.getFullYear()
  let m = date.getMonth() + 1
  let d = date.getDate()
  if (m >= 1 && m <= 9) {
    m = '0' + m
  }
  if (d >= 1 && d <= 9) {
    d = '0' + d
  }
  return String(year) + '-' + String(m) + '-' + String(d)
}

/**
 * @description 对象深拷贝
 */
function deepcopy(p) {
  return JSON.parse(JSON.stringify(p))
}

export {
	selfIsVNode,
	getRsaString,
  changeDateFormat,
  deepcopy
}


// WEBPACK FOOTER //
// ./src/assets/common/util.js